import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Card,
  TextField,
  Typography,
  CardActions,
  CardContent,
  InputAdornment,
  FormHelperText,
} from '@material-ui/core';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import { isMaxHourValid } from 'src/utils/inputValidations';
import { styles } from './styles';

const ScoresConfig = (props) => {
  const {
    scores, onSubmitScore, onChangeScores, onSubmitProcess,
  } = props;
  const initialError = {
    sumError: '',
    timeError: '',
    hourError: '',
    maxHourError: '',
    timeConError: '',
  };
  const [error, setError] = useState(initialError);
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const hourError = scores.tiempo_gestion_horas_max <= scores.tiempo_gestion_horas_min;
  const titleError = 'No debe ser mayor o igual';
  const tasaPeso = Number(scores.tasa_conversion_peso);
  const gestionPeso = Number(scores.tiempo_gestion_peso);
  return (
    <form onSubmit={onSubmitScore}>
      <Card>
        <CardContent className={classes.timeContainer}>
          <Typography className={classes.timeTitle}>
            Tiempo de Gestión
          </Typography>
          <Box className={classes.inputsContainer}>
            <div>
              <TextField
                error={error.sumError}
                className={classes.inputPercent}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                }}
                type="number"
                value={scores.tiempo_gestion_peso || ''}
                onChange={(event) => {
                  const sum = Number(event.target.value) + tasaPeso;
                  if (sum !== 100) {
                    const sumError = 'La suma de los pesos debe ser igual al 100%';
                    setError({ ...error, sumError });
                  } else {
                    setError({ ...error, sumError: '' });
                  }
                  onChangeScores(event.target.value, 'tiempo_gestion_peso');
                }}
                required
                id="peso"
                name="peso"
                label="Peso"
                variant="outlined"
              />
              <FormHelperText error>{error.sumError}</FormHelperText>
            </div>
            <div>
              <TextField
                className={classes.inputDias}
                error={error.timeError}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">Días</InputAdornment>
                  ),
                }}
                type="number"
                value={scores.tiempo_gestion_tiempo_ejecucion || ''}
                onChange={(event) => {
                  const isValid = isMaxHourValid(event.target.value);
                  if (!isValid) {
                    setError({ ...error, timeError: 'valor inválido' });
                  } else {
                    setError({ ...error, timeError: '' });
                  }
                  onChangeScores(
                    event.target.value,
                    'tiempo_gestion_tiempo_ejecucion',
                  );
                }}
                required
                id="tiempo_ejecucion"
                name="tiempo_ejecucion"
                label="Tiempo de Ejecución"
                variant="outlined"
              />
              <FormHelperText error>{error.timeError}</FormHelperText>
            </div>
            <div>
              <TextField
                error={error.hourError || hourError}
                className={classes.inputPercent}
                type="number"
                value={scores.tiempo_gestion_horas_min || ''}
                onChange={(event) => {
                  const isValid = isMaxHourValid(event.target.value);
                  if (!isValid) {
                    setError({ ...error, hourError: 'valor inválido' });
                  } else {
                    setError({ ...error, hourError: '' });
                  }
                  onChangeScores(event.target.value, 'tiempo_gestion_horas_min');
                }}
                required
                id="minimo_horas"
                name="minimo_horas"
                label="Mínimo de Horas"
                variant="outlined"
              />
              {hourError ? (
                <FormHelperText error>{titleError}</FormHelperText>
              ) : null}
              <FormHelperText error>{error.hourError}</FormHelperText>
            </div>
            <div>
              <TextField
                error={error.maxHourError || hourError}
                className={classes.inputPercent}
                type="number"
                value={scores.tiempo_gestion_horas_max || ''}
                onChange={(event) => {
                  const isValid = isMaxHourValid(event.target.value);
                  if (!isValid) {
                    setError({ ...error, maxHourError: 'valor inválido' });
                  } else {
                    setError({ ...error, maxHourError: '' });
                  }
                  onChangeScores(event.target.value, 'tiempo_gestion_horas_max');
                }}
                required
                id="maximo_horas"
                name="maximo_horas"
                label="Máximo de Horas"
                variant="outlined"
              />
              <FormHelperText error>{error.maxHourError}</FormHelperText>
            </div>
          </Box>
        </CardContent>
        <CardContent className={classes.timeContainer}>
          <Typography className={classes.timeTitle}>
            Tasa de Conversión
          </Typography>
          <Box className={classes.inputsContainer}>
            <div>
              <TextField
                error={error.sumError}
                className={classes.inputPercent}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                }}
                type="number"
                value={scores.tasa_conversion_peso || ''}
                onChange={(event) => {
                  const sum = Number(event.target.value) + gestionPeso;
                  if (sum !== 100) {
                    const sumError = 'La suma de los pesos debe ser igual al 100%';
                    setError({ ...error, sumError });
                  } else {
                    setError({ ...error, sumError: '' });
                  }
                  onChangeScores(event.target.value, 'tasa_conversion_peso');
                }}
                required
                id="peso_conversion"
                name="peso_conversion"
                label="Peso"
                variant="outlined"
              />
              <FormHelperText error>{error.sumError}</FormHelperText>
            </div>
            <div>
              <TextField
                error={error.timeConError}
                className={classes.inputDias}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">Días</InputAdornment>
                  ),
                }}
                type="number"
                value={scores.tasa_conversion_tiempo_ejecucion || ''}
                onChange={(event) => {
                  const isValid = isMaxHourValid(event.target.value);
                  if (!isValid) {
                    setError({ ...error, timeConError: 'valor inválido' });
                  } else {
                    setError({ ...error, timeConError: '' });
                  }
                  onChangeScores(
                    event.target.value,
                    'tasa_conversion_tiempo_ejecucion',
                  );
                }}
                required
                id="tiempo_ejecucion_conversion"
                name="tiempo_ejecucion_conversion"
                label="Tiempo de Ejecución"
                variant="outlined"
              />
              <FormHelperText error>{error.timeConError}</FormHelperText>
            </div>
          </Box>
        </CardContent>
        <CardActions>
          <Button
            type="submit"
            color="warning"
            disabled={
              error.sumError !== ''
              || error.maxHourError !== ''
              || error.hourError !== ''
              || error.timeConError !== ''
              || error.timeError !== ''
              || hourError
            }
          >
            Guardar
          </Button>
          <Button
            onClick={onSubmitProcess}
            color="warning"
            disabled={
              error.sumError !== ''
              || error.maxHourError !== ''
              || error.hourError !== ''
              || error.timeConError !== ''
              || error.timeError !== ''
              || hourError
            }
          >
            Procesar
          </Button>
        </CardActions>
      </Card>
    </form>
  );
};

export default ScoresConfig;
